import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import { withRouter } from "react-router-dom";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getlanguagelist } from "../../helpers/changelanguage";
import ChatBox from "./ChatBox";
import AllChat from "./AllChat";
import { getChatlist } from "../../actions/chatAction";
import $$ from 'jquery';


class Chatbar extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            serchchat   : null,
            pagination  : 0,
            chatlist    : [],
            chatPersons : [],
            chat_list_display : false,
            all_chatList_display : true,
            last_res_counter  : 0
        };

        this.getChatlist        = this.getChatlist.bind(this);
        this.openChatBox        = this.openChatBox.bind(this);
        this.openChatList       = this.openChatList.bind(this);
        //this.loadChatList       = this.loadChatList.bind(this);
        this.closeAllChatList   = this.closeAllChatList.bind(this);

    };

    componentDidMount(){
        // this.getChatlist();
    }
    openChatBox(arr){
        this.setState({
            chatPersons   : arr
        });
    }
    openChatList(val){
        
        this.setState({
            chat_list_display   : val
        });
    }
    
    componentWillUnmount() {
        localStorage.setItem('apicall','0');
    }

    closeAllChatList(val){
        this.setState({
            all_chatList_display   : val
        });
    }

    getChatlist(){
        localStorage.setItem('apicall','1');

        let param = {
          search     : this.state.serchchat,
          pagination : this.state.pagination
        }
        
        let chatlist = this.props.getChatlist(param);
    }

    UNSAFE_componentWillReceiveProps(nextProps,prevProps,prevState){  
        let chats = this.state.chatlist;
        
        if(this.props.chatlist != nextProps.chatlist){
            
            if (this.state.pagination == 0) {
                chats =  [...nextProps.chatlist];
            }else{
                let nextchats = nextProps.chatlist;
                
                if(nextchats !== this.props.chatlist){
                  Object.keys(nextchats).map((key) => {
                    chats.push(nextchats[key]);
                  });
                }
            }
            
            
            localStorage.setItem('apicall','0');            
            this.setState({
                chatlist   : chats,
                last_res_counter  : nextProps.chatlist.length,
            });

        }
        
    }
    
    
    render() {
        
        return (
            <div>
                <AllChat 
                    // chatlist = {this.state.chatlist}
                    openChatBox = {this.openChatBox} 
                    openChatList = {this.openChatList}
                    all_chatList_display = {this.state.all_chatList_display}
                    />
                <ChatBox 
                    chatPersons = {this.state.chatPersons}
                    displayChatList = {this.state.chat_list_display}
                    closeAllChatList = {this.closeAllChatList}
                    />
            
                
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        me         : state.login.user,
        chatlist   : state.chatuserlist.chatList.list,
    }
}

const mapDispatchToProps = dispatch => {
    return {
      getChatlist      : bindActionCreators(getChatlist, dispatch),
    }
}

//export default Chatbar;
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
  )(Chatbar));